import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

const LitioValues = () => {
  return (
    <TableContainer>
      <Table>
        <Thead>
          <Tr>
            <Th>Fase do tratamento</Th>
            <Th>Concentração sérica</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>Fase aguda (episódios)</Td>
            <Td>0,8-1,2 mEq/L</Td>
          </Tr>
          <Tr>
            <Td>Manutenção (profilaxia)</Td>
            <Td>0,6-0,8 mEq/L</Td>
          </Tr>
          <Tr>
            <Td>Idosos / maior sensibilidade</Td>
            <Td>0,4-0,6 mEq/L</Td>
          </Tr>
          <Tr>
            <Td>Tóxico</Td>
            <Td>{`>1,5 mEq/L`}</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default LitioValues;
